import { render, staticRenderFns } from "./OrgHeader.vue?vue&type=template&id=2ff3970e&scoped=true"
import script from "./OrgHeader.vue?vue&type=script&lang=js"
export * from "./OrgHeader.vue?vue&type=script&lang=js"
import style0 from "./OrgHeader.vue?vue&type=style&index=0&id=2ff3970e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff3970e",
  null
  
)

export default component.exports